import { useContext, useEffect, useState } from "react";
import restService from "../../../../restService";
import UserContext from "../../../../contexts/UserContext";
import CampaignContext from "../../../../contexts/CampaignContext";

const AccountSettings = () => {
  const [user] = useContext(UserContext);
  const [campaign, setCampaign] = useContext(CampaignContext);

  const [loading, setLoading] = useState(false);
  const [newCampaignName, setNewCampaignName] = useState(campaign.name);

  // useEffect(() => {
  //   console.log(user);
  //   console.log(campaign);
  // }, []);

  const handleCampaigNameChange = async () => {
    setLoading(true);
    const companyData = { name: newCampaignName };

    try {
      const {
        data: { message },
      } = await restService.Settings.updateCompany(campaign.id, companyData);

      await getCampaign(campaign.id);
      // setCampaign({ ...campaign, name: newCampaignName });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }

    // const data = { name: newCampaignName };
    // restService.Settings.updateCompany(campaign.id, data)
    //   .then(() => {

    //   })
    //   .catch(console.log)
    //   .finally(() => {
    //     setLoading(false);
    //   });
  };

  const getCampaign = async (appId) => {
    try {
      const {
        data: { code, results },
      } = await restService.Auth.getCompany(appId);
      setCampaign(results);
      // console.log(results);
      sessionStorage.setItem("CAMPAIGN", JSON.stringify(results));
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="flex flex-col gap-8">
      <div className="p-[32px] bg-white rounded shadow">
        <p>Account Settings</p>

        <div className="flex justify-between flex-col md:flex-row items-center gap-8 mt-10">
          <div className="w-full flex  gap-3 items-center ">
            <div className="w-full flex flex-col">
              <label htmlFor="accountName" className="text-sm text-[#24211D]">
                Account Name
              </label>
              <input
                type="text"
                className="w-full text-[#c9c9c9] p-3 text-sm border mt-3 disabled:border-[#e9e9e9] rounded"
                id="accountName"
                value={user.username}
                onChange={() => {}}
                disabled
              />
            </div>
          </div>

          <div className="w-full flex flex-col">
            <label htmlFor="email" className="text-sm text-[#24211D]">
              Email Address
            </label>
            <input
              type="text"
              className=" w-full text-[#c9c9c9] p-3 text-sm border mt-3 disabled:border-[#e9e9e9] rounded"
              id="email"
              value={user.email}
              onChange={() => {}}
              disabled
            />
          </div>
        </div>

        <button
          disabled
          className="bg-[#3989DD] disabled:bg-[#ededed] mt-9 py-2 px-5 text-white rounded"
        >
          Save Changes
        </button>
      </div>

      <div className="p-[32px] mb-5 bg-white rounded shadow">
        <p>Campaign Details</p>

        <div className="flex justify-between items-center gap-8 mt-10">
          <div className="w-full flex gap-3 items-center ">
            <div className="flex md:w-2/4 w-full flex-col">
              <label htmlFor="campaignName" className="text-sm text-[#24211D]">
                Campaign Name
              </label>
              <input
                type="text"
                className="w-full text-[#787878] p-3 text-sm border mt-3 border-[#DCDCDC] rounded"
                id="campaignName"
                value={newCampaignName}
                onChange={(e) => {
                  setNewCampaignName(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <button
          onClick={handleCampaigNameChange}
          disabled={
            loading ||
            newCampaignName === campaign.name ||
            newCampaignName === ""
          }
          className="bg-[#3989DD] hover:bg-[#2a67a8] disabled:bg-[#dcdbdb] mt-9 py-2 px-5 text-white rounded"
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default AccountSettings;
